import api from "./api";

export interface PurchaseItem {
  product_id: number;
  product_code: string;
  product_name: string;
  unit_cost: number;
  quantity: number;
  subtotal: number;
  grand_total: number;
  tax_id?: number;
  tax?: number;
  discount?: number;
}

export interface Purchase {
  id?: number;
  ref: string;
  date: string;
  warehouse_id: number;
  warehouse_code?: string;
  warehouse_name?: string;
  supplier_id: number;
  supplier_code?: string;
  supplier_name?: string;
  branch_id?: number;
  branch_code?: string;
  branch_name?: string;
  order_tax?: number;
  tax?: number;
  tax_rate?: number;
  discount?: number;
  shipping?: number;
  grand_total: number;
  paid: number;
  status: string;
  payment_status: string;
  notes?: string;
  items: PurchaseItem[];
  created_at?: string;
  payments?: Array<{
    id?: number;
    amount?: number;
    paid_by?: string;
    note?: string;
    method_id?: number;
    created_at?: string;
    method?: {
      id?: number;
      name?: string;
    };
  }>;
}

export interface PurchasePaymentPayload {
  amount: number;
  method_id: number;
  paid_by?: string;
  note?: string;
}

export interface PurchaseListResponse {
  current_page: number;
  data: Purchase[];
  from: number | null;
  last_page: number;
  links: Array<{ label: string; active: boolean; url: string | null }>;
  per_page: number;
  to: number | null;
  total: number;
}

export const createPurchase = async (purchase: Purchase) => {
  const response = await api.post("/purchases-in", purchase);
  return response.data;
};

export const getPurchases = async (params: any = {}): Promise<PurchaseListResponse> => {
  const response = await api.get("/purchases-in", { params });
  return response.data;
};

export const getPurchase = async (id: number | string) => {
  const response = await api.get(`/purchases-in/${id}`);
  return response.data;
};

export const updatePurchase = async (id: number | string, purchase: any) => {
  const response = await api.put(`/purchases-in/${id}`, purchase);
  return response.data;
};

export const deletePurchase = async (id: number | string) => {
  const response = await api.delete(`/purchases-in/${id}`);
  return response.data;
};

export const getNextReference = async () => {
  const response = await api.get("/purchases-in/next-reference");
  return response.data.data ?? response.data;
};

export const exportPurchases = async (params: any = {}) => {
  const response = await api.get("/purchases-in", {
    params: {
      export: 1,
      ...params,
    },
    responseType: "blob",
  });

  return response.data as Blob;
};

export const importPurchases = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post("/purchases-in/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const addPurchasePayment = async (
  id: number | string,
  payload: PurchasePaymentPayload
) => {
  const response = await api.post(`/purchases-in/${id}/payments`, payload);
  return response.data;
};

export const updatePurchasePayment = async (
  id: number | string,
  paymentId: number | string,
  payload: PurchasePaymentPayload
) => {
  const response = await api.put(`/purchases-in/${id}/payments/${paymentId}`, payload);
  return response.data;
};

export const deletePurchasePayment = async (
  id: number | string,
  paymentId: number | string
) => {
  const response = await api.delete(`/purchases-in/${id}/payments/${paymentId}`);
  return response.data;
};
